import { _x } from '@wordpress/i18n';

document.addEventListener('facetwp-loaded', function () {
  if (window.FWP.loaded) {
    const notice = document.querySelector(
      '.facetwp-template .results-updated-notice--has-results'
    );
    const noticeNoResults = document.querySelector(
      '.facetwp-template .results-updated-notice--no-results'
    );
    if (notice) {
      notice.textContent = _x(
        'Results were updated according to your search criterias.',
        'listing no result',
        'vtx'
      );
      notice.focus();
    } else if (noticeNoResults) {
      noticeNoResults.focus();
    }
  }
});
